"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { CreateWaveOutcomeConfig } from "@/types/waves.types";
import { CreateWaveOutcomeType } from "@/types/waves.types";
import RepCategorySearch from "@/components/utils/input/rep-category/RepCategorySearch";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesRepApprove(t0) {
  const $ = _c(39);
  const {
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.REP;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [categoryError, setCategoryError] = useState(false);
  const [creditError, setCreditError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = category => {
      setCategoryError(false);
      setOutcome({
        ...outcome,
        category
      });
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setCategory = t2;
  let t3;
  if ($[3] !== outcome) {
    t3 = e => {
      const newCredit = parseFloat(e.target.value);
      const isValid = !isNaN(newCredit) && newCredit >= 0;
      setOutcome({
        ...outcome,
        credit: isValid ? newCredit : null
      });
      setCreditError(false);
    };
    $[3] = outcome;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setCredit = t3;
  let t4;
  if ($[5] !== onOutcome || $[6] !== outcome) {
    t4 = () => {
      const dontHaveCategorySet = !outcome.category;
      const dontHaveCreditSet = !outcome.credit;
      setCategoryError(dontHaveCategorySet);
      setCreditError(dontHaveCreditSet);
      if (dontHaveCategorySet || dontHaveCreditSet) {
        return;
      }
      onOutcome(outcome);
    };
    $[5] = onOutcome;
    $[6] = outcome;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onSubmit = t4;
  let t5;
  if ($[8] !== categoryError || $[9] !== outcome.category || $[10] !== setCategory) {
    t5 = <div className="tw-flex tw-w-full tw-flex-col tw-gap-4 tw-pt-[0.5px] sm:tw-flex-row"><RepCategorySearch error={categoryError} category={outcome.category} setCategory={setCategory} /></div>;
    $[8] = categoryError;
    $[9] = outcome.category;
    $[10] = setCategory;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== outcome.credit) {
    t6 = outcome.credit !== null ? outcome.credit.toString() : "";
    $[12] = outcome.credit;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = `${creditError ? "tw-caret-error tw-ring-error focus:tw-border-error focus:tw-ring-error" : "tw-caret-primary-400 tw-ring-iron-650 focus:tw-border-blue-500 focus:tw-ring-primary-400"} ${outcome.credit ? "tw-text-primary-400 focus:tw-text-white" : "tw-text-white"} tw-peer tw-form-input tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-border-iron-600 tw-bg-iron-900 tw-px-4 tw-pb-3 tw-pt-4 tw-text-base tw-font-medium tw-shadow-sm tw-ring-1 tw-ring-inset tw-transition tw-duration-300 tw-ease-out placeholder:tw-text-iron-500 focus:tw-bg-iron-900 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset sm:tw-text-sm`;
  let t8;
  if ($[14] !== setCredit || $[15] !== t6 || $[16] !== t7) {
    t8 = <input type="text" value={t6} onChange={setCredit} id="outcome-rep-credit" autoComplete="off" className={t7} placeholder=" " />;
    $[14] = setCredit;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = `${creditError ? "peer-focus:tw-text-error" : "peer-focus:tw-text-primary-400"} tw-absolute tw-start-1 tw-top-2 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-cursor-text tw-bg-iron-900 tw-px-2 tw-text-base tw-font-normal tw-text-iron-500 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-900 peer-focus:tw-px-2 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4`;
  let t10;
  if ($[18] !== t9) {
    t10 = <label htmlFor="outcome-rep-credit" className={t9}>Rep</label>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t8) {
    t11 = <div className="tw-group tw-relative tw-w-full">{t8}{t10}</div>;
    $[20] = t10;
    $[21] = t8;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== creditError) {
    t12 = creditError && <div className="tw-flex tw-items-center tw-gap-x-2 tw-pt-1.5"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><div className="tw-text-xs tw-font-medium tw-text-error">Rep must be a positive number</div></div>;
    $[23] = creditError;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12) {
    t13 = <div className="tw-grid tw-gap-x-5"><div>{t11}{t12}</div></div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== onCancel) {
    t14 = <button onClick={onCancel} type="button" className="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-800 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-border-iron-700 hover:tw-bg-iron-700">Cancel</button>;
    $[28] = onCancel;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== onSubmit) {
    t15 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[30] = onSubmit;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t14}{t15}</div>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t13 || $[36] !== t16 || $[37] !== t5) {
    t17 = <div className="tw-col-span-full"><div className="tw-flex tw-flex-col tw-gap-y-5">{t5}{t13}{t16}</div></div>;
    $[35] = t13;
    $[36] = t16;
    $[37] = t5;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
}